// removed by extract-text-webpack-plugin
module.exports = {"gridContainer":"_1DdGU","item":"_1DHBs","image":"U5Hzq","itemDetails":"_1Lh3n"};